import React from 'react';
export function HookSection() {
  return <section className="relative w-full py-12 px-4 bg-zinc-900/50 border-y border-zinc-800/50" data-id="element-71">
      {/* Asphalt texture overlay */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 300 300%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%225%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-72" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-73">
        <div className="bg-zinc-950/80 border-l-4 border-[#C5A014] p-6 md:p-8 shadow-2xl" data-id="element-74">
          <p className="font-['Crimson_Text'] text-xl md:text-2xl lg:text-3xl text-zinc-200 leading-relaxed" data-id="element-75">
            No nació en las selvas de Colombia ni en las sierras de Sinaloa;
            nació en el rincón más inesperado:{' '}
            <span className="text-[#C5A014] font-semibold" data-id="element-76">Uruguay</span>. Esta
            es la historia del broker logístico que movió{' '}
            <span className="text-[#C5A014] font-semibold" data-id="element-77">
              16 toneladas de cocaína
            </span>{' '}
            mientras el mundo lo buscaba.
          </p>
        </div>
      </div>
    </section>;
}